"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 531 155.18",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M568.46,254.25a7.49,7.49,0,0,0-7.18-5.34h-9.82l14-9.25a7.5,7.5,0,0,0-4.14-13.75H197.46a7.46,7.46,0,0,0-3.18.71L42.1,297.8a7.5,7.5,0,0,0,3.18,14.29H60.72L42.1,320.8a7.5,7.5,0,0,0,3.18,14.29H60.72L42.1,343.8a7.5,7.5,0,0,0,3.18,14.29H60.72L42.1,366.8a7.5,7.5,0,0,0,3.18,14.29H453.83a7.46,7.46,0,0,0,4.14-1.25l107.45-71.18a7.5,7.5,0,0,0-4.14-13.75h-9.82l14-9.25a7.5,7.5,0,0,0-4.14-13.75h-9.82l14-9.25A7.48,7.48,0,0,0,568.46,254.25ZM79,297.09l120.11-56.18H536.38l-12.08,8-22.64,15-12.08,8-22.64,15-12.08,8-3.29,2.18H79Zm457.36,12.82-84.81,56.18H79l17.1-8H453.83a7.46,7.46,0,0,0,4.14-1.25l70.85-46.93Zm0-23-12.08,8-22.64,15-50.09,33.18H79l17.1-8H453.83a7.46,7.46,0,0,0,4.14-1.25l36.13-23.93,22.64-15,12.08-8Zm-34.72,0-12.08,8-22.64,15-15.37,10.18H79l17.1-8H453.83a7.46,7.46,0,0,0,4.14-1.25l1.41-.93,22.64-15,12.08-8,22.64-15,12.08-8h7.56l-12.08,8Z",
      transform: "translate(-37.78 -225.91)"
    })
  });
};

exports.default = Icon;